<template>
    <div class="freeSourceCode">
        <div v-if="banner && banner.length" class="freeSourceCode-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)">
        </div>
        <div class="freeSourceCode-body">
            <div class="freeSourceCode-tabs">
                <!-- <template v-for='(tab, key) in tabs'>
                    <Tabs 
                        :tabsList="tab" 
                        :key="key" 
                        :tabKey="key" 
                        :activeType="activeTab[key]" 
                        @handleTab="handleTab" />
                </template> -->
                <el-tabs v-model="tabName" @tab-click="setTabPane(tabName)">

                    <el-tab-pane :label="item.categoryName" v-for="item in tabList" :name="`${item.categoryId}`">
                        <svg-icon v-if="item.newStatus === 1" icon-class="new" class-name="icon-new-top"></svg-icon>
                        <div class="tab-item" v-if="activeTab.categoryTwo && tabName!=='null'">
                            分类：
                            <span :class="{'active': activeTab.categoryTwo === 'o'}" @click="setCategory('o')">全部</span>	
                            <span :class="{'active': String(activeTab.categoryTwo) === String(subItem.categoryId)}"  @click="setCategory(subItem.categoryId)" v-for="subItem in item.childList" :key="subItem.categoryId">
                                <svg-icon v-if="subItem.newStatus === 1" icon-class="new" class-name="icon-new"></svg-icon>
                                {{subItem.categoryName}}
                            </span>
                        </div>
                        <div class="tab-item">
                            技术：
                            <span :class="{'active': activeTab.techId === 'o'}" @click="setTech('o')">全部</span>	
                            <span :class="{'active': String(activeTab.techId) === String(subItem.categoryId)}" @click="setTech(subItem.categoryId)" v-for="subItem in item.techChildList" :key="subItem.categoryId">{{subItem.categoryName}}</span>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- <el-select size="mini"  v-model="activeTab.sort" @change="handleTab('sort',activeTab.sort)">
                <el-option  label="综合排序" value="1"></el-option>
                <el-option  label="最近更新" value="2"></el-option>
                <el-option  label="最多下载" value="3"></el-option>
                <el-option  label="最多收藏" value="4"></el-option>
                <el-option  label="免费素材" value="5"></el-option>
                <el-option  label="付费素材" value="6"></el-option>
            </el-select>
            <el-select size="mini" style="margin-left:20px;width:140px" v-if="tabName === bigScreenType"  v-model="activeTab.size" @change="handleTab('size',activeTab.size)">
                <el-option  label="全部尺寸" value=""></el-option>
                <el-option v-for="item in sizeList" :key="item.size" :label="item.name" :value="item.size"></el-option>
            </el-select>
            <el-select size="mini" style="margin-left:20px;width:140px" v-model="activeTab.twoSort" @change="handleTab('twoSort',activeTab.twoSort)">
                <el-option  label="价格排序" value=""></el-option>
                <el-option  label="价格由低到高" value="2"></el-option>
                <el-option  label="价格由高到低" value="1"></el-option>
            </el-select> -->
            <!-- 素材列表 -->
            <source-code-list :tab="activeTab" SourceCodeType="1" />

        </div>
    </div>
</template>

<script>
import { getSourceCodeCategory } from '@/api/sourceCode';
import { getBannerURL } from '@/api/common';
import SourceCodeList from './components/SourceCodeList';
import Tabs from '@/components/Tabs';


export default {
    name: 'SourceCode',
    components: {
        SourceCodeList,
        Tabs
    },
    data: () => ({
        tabName:'',
        tabs: {
			label: [{
				type: '',
				title: '全部标签'
			}],
			category: [{
				type: '',
				title: '全部分类'
			}],
			format: [{
				type: '',
				title: '全部格式'
			}]
        },
        bigScreenType:'',
        tabList:[],
        formatList:[],
        activeTab: {
			techId: sessionStorage.getItem('source_code_techIdTab') || 'o',
			categoryOne: sessionStorage.getItem('source_code_categoryOneTab') || 'null',
			categoryTwo: sessionStorage.getItem('source_code_categoryTwoTab') || 'o',
			// title: sessionStorage.getItem('source_code_formatTab') || '',
			// size: sessionStorage.getItem('source_code_sizeTab') || '',
			// twoSort: sessionStorage.getItem('source_code_sizeTab') || ''
		},
        sizeList:[],
        topCategory:'',
        banner: '', // banner图地址
    }),
    created() {
        // 从路由参数获取分类和技术ID
        const categoryOne = this.$route.params.type || 'null';
        const categoryTwo = this.$route.params.subType || 'o';
        const techId = this.$route.params.techId || 'o';
        
        // 更新组件状态
        this.activeTab = {
            categoryOne: String(categoryOne),
            categoryTwo: String(categoryTwo),
            techId: String(techId)
        };
        
        // 设置顶级分类和当前标签页
        this.topCategory = String(categoryOne);
        this.tabName = String(categoryOne);
        
        // 保存到sessionStorage
        sessionStorage.setItem('source_code_categoryOneTab', String(categoryOne));
        sessionStorage.setItem('source_code_categoryTwoTab', String(categoryTwo));
        sessionStorage.setItem('source_code_techIdTab', String(techId));
        
        console.log('初始化activeTab:', this.activeTab);
    },
    mounted() {
        this.getTabs();
        // this.getBannerURL();
        // this.getFormatList();
        // this.getSizeList()
    },
    methods: {
        setTabPane(id) {
            console.log('设置一级分类id: ', id);
            
            // 确保id为字符串类型
            const categoryId = String(id);
            
            // 切换一级分类时，重置二级分类和技术ID，更新URL
            this.$router.replace(`/sourceCode/${categoryId}`);
            
            // 更新数据状态
            this.activeTab = {
                categoryOne: categoryId,
                categoryTwo: 'o',
                techId: 'o'
            };
            this.topCategory = categoryId;
            this.tabName = categoryId;
            
            // 保存到本地存储和sessionStorage
            sessionStorage.setItem('source_code_categoryOneTab', categoryId);
            sessionStorage.setItem('source_code_categoryTwoTab', 'o');
            sessionStorage.setItem('source_code_techIdTab', 'o');
            this.handleTab('categoryOne', categoryId);
            this.handleTab('categoryTwo', 'o');
            this.handleTab('techId', 'o');
        },
        setCategory(id) {
            console.log('设置二级分类id: ', id);
            
            // 保留当前技术ID参数
            const techPath = this.activeTab.techId !== 'o' ? `/${this.activeTab.techId}` : '';
            
            // 更新URL，保留当前技术ID参数
            this.$router.replace(`/sourceCode/${this.topCategory}/${id}${techPath}`);
            
            // 更新数据状态
            this.activeTab.categoryTwo = String(id); // 确保保存为字符串
            
            // 保存到本地存储和sessionStorage
            sessionStorage.setItem('source_code_categoryTwoTab', String(id));
            this.handleTab('categoryTwo', String(id));
        },
        setTech(id) {
            console.log('设置技术id: ', id);
            
            // 构建URL路径
            // 更新URL，格式为：/sourceCode/{一级分类}/{二级分类}/{技术id}
            const categoryId = this.activeTab.categoryTwo;
            const techPath = id !== 'o' ? `/${id}` : '';
            this.$router.replace(`/sourceCode/${this.topCategory}/${categoryId}${techPath}`);
            
            // 更新数据状态
            this.activeTab.techId = String(id); // 确保保存为字符串
            
            // 保存到本地存储
            this.handleTab('techId', String(id));
            
            // 保存到sessionStorage
            sessionStorage.setItem('source_code_techIdTab', String(id));
        },
        openBanner(imgUrl) {
            window.open(imgUrl);
        },
        async getFormatList() {
            try {
                const { data:formatList } = await getAllFormat();
                this.formatList = formatList || []
            } catch (error) {
                console.log('error: ', error);
                
            }
        },
        async getSizeList() {
            try {
                const { data:sizeList } = await getSizeList();
                this.sizeList = sizeList || []
            } catch (error) {
                console.log('error: ', error);
                
            }
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(5).then(({ data }) => {
                this.banner = (data || []).splice(0,2);
            });
        },
        getTabs() {
            getSourceCodeCategory().then(res => {
                const list = res.data || []
                this.tabList = list
                
                // 如果路由没有指定分类，则选择第一个分类
                if (!this.$route.params.type && list.length > 0){
                    const firstCategoryId = String(list[0].categoryId);
                    this.tabName = firstCategoryId;
                    this.activeTab.categoryOne = firstCategoryId;
                    this.topCategory = firstCategoryId;
                    
                    // 更新URL，使用路由器而不是直接操作history
                    this.$router.replace(`/sourceCode/${firstCategoryId}/o`);
                    
                    // 保存到sessionStorage
                    sessionStorage.setItem('source_code_categoryOneTab', firstCategoryId);
                    sessionStorage.setItem('source_code_categoryTwoTab', 'o');
                    sessionStorage.setItem('source_code_techIdTab', 'o');
                } else {
                    // 确保tabName与当前一级分类一致
                    this.tabName = String(this.activeTab.categoryOne);
                }
                
                console.log('设置tabName:', this.tabName, '当前activeTab:', this.activeTab);
            })
        },
        handleTab(type, key) {
            sessionStorage.setItem(`source_code_${key}Tab`, type)
            sessionStorage.setItem(this.$route.path, 1)
        }
    },
    watch: {
        // 监听路由变化
        $route(to) {
            // 从路由参数获取分类和技术ID
            const categoryOne = to.params.type || 'null';
            const categoryTwo = to.params.subType || 'o';
            const techId = to.params.techId || 'o';
            
            // 更新组件状态
            this.activeTab = {
                categoryOne: String(categoryOne),
                categoryTwo: String(categoryTwo),
                techId: String(techId)
            };
            
            // 设置顶级分类和当前标签页
            this.topCategory = String(categoryOne);
            this.tabName = String(categoryOne);
            
            // 保存到sessionStorage
            sessionStorage.setItem('source_code_categoryOneTab', String(categoryOne));
            sessionStorage.setItem('source_code_categoryTwoTab', String(categoryTwo));
            sessionStorage.setItem('source_code_techIdTab', String(techId));
            
            console.log('路由变化更新activeTab:', this.activeTab);
        }
    }
};
</script>

<style lang="scss" scoped>
.freeSourceCode {
    &-tabs {
        padding-bottom: 10px;
		border-bottom: 1px solid rgba(224, 228, 247, 1);
        margin-bottom: 10px;
		.base-tabs {
			// margin-bottom: 20px;
		}
	}
	&-banner {
        // padding: 20px 0;
        // background-color: #fff;
        text-align: center;
        font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
        > img {
            cursor: pointer;
            flex:1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
            font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
        }
    }
    
    &-body {
        margin: 0 auto;
        padding-top: 20px;
        width: 1600px;
        /deep/ .el-tabs__content {
            overflow: visible;
        }
        /deep/ .el-tabs__item {
            font-size: 16px;
            color: #272c40;
            &:hover {
                color:#2C54EF;
            }
            &.is-active {
                color:#2C54EF;
                font-weight: 600;
            }
        }
        /deep/ .el-select {
            width: 110px;
            input {
                font-size: 14px;
            }
        }
        .icon-new-top {
            position: absolute;
            right: 0px;
            top: 0px;
        }
        /deep/ .el-input__inner {
            background: #f5f6f9;
        }
    }
    .tab-item {
        margin-bottom: 9px;
        color:#a4a7b4;
        font-size: 16px;
        span {
            margin-right: 20px;
            padding: 3px 8px;
            display: inline-block;
            color: #272c40;
            font-size: 16px;
            cursor: pointer;
            position: relative;
            &:hover {
                color:#2C54EF;
            }
            &.active {
                color: #2F54EB;
                background: #DCE3FD;
                border-radius: 4px;
            }
            .icon-new {
                position: absolute;
                right: 0px;
                top: -10px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .freeSourceCode {
        &-body {
            width: 1200px;
        }
        &-tabs {
            padding-bottom: 4px;
			.base-tabs {
				margin-bottom: 14px;
			}
        }
    }
}
</style>
